module.exports = __webpack_public_path__ + "img/twitter.b3d2508c.svg";